module.exports = __webpack_public_path__ + "img/festivalohnebands.d1981bd3.png";